export interface ISelectData {
    value: string,
    label: string | number,
}

export interface IFormData {
    paySum: number,
    payCard: number,
    payBonuses: number,
    email: string | ISelectData,
    useBonuses: boolean,
    connectAutoPay: boolean,
}

export type TField = {
    value: string,
    isValid: boolean,
    clearInput: () => void,
}

export const defaultFormData: IFormData = {
    paySum: 0,
    payCard: 0,
    email: '',
    payBonuses: 0,
    useBonuses: false,
    connectAutoPay: false,
};

export interface IAgreementData {
    label: string,
    value: string,
    contact: string,
    rowEnc: string | null,
    phone: string,
}

export const defaultAgreementData: IAgreementData = {
    label: '',
    value: '',
    contact: '',
    rowEnc: '',
    phone: '',
};

export type TMenuItem = {
    value: string,
    text: string,
    action: () => void,
}
